import { render } from "./OffersCategories.vue?vue&type=template&id=60dfac96&scoped=true"
import script from "./OffersCategories.vue?vue&type=script&lang=js"
export * from "./OffersCategories.vue?vue&type=script&lang=js"

import "./OffersCategories.vue?vue&type=style&index=0&id=60dfac96&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\weapon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60dfac96"]])

export default __exports__